export const CREDENTIALS_COOKIE = {
	key: 'brbadmincred',
	expires: 60 * 60 * 2.5 * 1000,
	path: '/',
	sameSite: 'Strict',
	secure:
		(import.meta.env.SSL_ENABLED &&
			import.meta.env.env.SSL_ENABLED === 'true') ||
		false
}
